import _NackleMenu from './nackle-menu.js';
export default _NackleMenu;
//# sourceMappingURL=index.js.map